import { getApiRequest, universalApiRequest } from 'api';
import { AxiosRequestConfig } from 'axios';
import { IMetaCatalogRequestResponse, IMetaResponse } from 'types/meta';

export const loadMetaRequest = (): Promise<IMetaResponse> => getApiRequest('/meta/');

export const loadMetaCatalogRequest = (config: AxiosRequestConfig): Promise<IMetaCatalogRequestResponse> =>
    universalApiRequest(config);
